<script>

    import { toast } from 'bulma-toast'
    import { userStore, creditsStore, modalStore } from '../stores'

    import CreditsService from '../$services/credits.service'
    import DateMethod from '../$methods/date.method'
    import NumeralMethods from '../$methods/numeral.methods'
    import TranslateMethods from '../$methods/translate.methods.js'

    import Pagination from '../$components/pagination.svelte'
    import Select from '../$components/select.svelte'
    import Search from '../$components/input.search.svelte'
    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'

    export let all = false

    let query = {
        page: 0,
        find: null
    }
    let metadata = {}
    let loading = false
    let element

    getCredits()

    async function getCredits() {

        if(all)
            query.admin = true
        else
            query.userId = $userStore._id

        loading = true
        const resp = await CreditsService.getCredits(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        creditsStore.set(resp.data.credits)
        metadata = resp.data.metadata
    }

    async function getCreditsReport() {

        loading = true
        const blob = await CreditsService.getCreditsReport()
        loading = false

        if(!blob)
            toast({message: resp.error.message, type: 'is-danger'})

        let fileName = 'Reporte_creditos'

        element.download = `${fileName}.xlsx`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<a bind:this={element} style="display: none;" href="/">.</a>

<Table items={ $creditsStore.length } total={ metadata.total } { loading } showToolbarArea={all} showFooterActions={true}>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            <div class="column">
                <Search bind:value={ query.find } on:enter={ getCredits } />
            </div>
            <div class="column is-narrow">
                <Select bind:value={ query.status } on:change={ getCredits }
                    text="Estatus de pago"
                    options={[
                        {value: 'pending', text: 'Pendiente'},
                        {value: 'paid', text: 'Pagado'},
                        {value: 'free', text: 'Gratis'},
                    ]}
                />
            </div>
            <div class="column is-narrow">
                <div class="credits-toolbar-actions">
                    <Button on:click={getCreditsReport} icon="file-excel" text="Descargar reporte" />
                </div>
            </div>
        </div>
    </div>
    <div slot="footer">
        <Pagination bind:metadata bind:page={ query.page } on:change={ getCredits } />
    </div>
    <thead>
        <tr>
            <th>#</th>
            <th>Usuario</th>
            <th>Estatus</th>
            <th>Método</th>
            <th>Monto</th>
            <th>Fecha</th>
            <th class="has-text-right">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $creditsStore as credit, index}
            <tr>
                <td>{(metadata.items * query.page) + (index + 1)}</td>
                <td>
                    <div>
                        <div>{credit.user.name}</div>
                        <div>{credit.user.email}</div>
                    </div>
                </td>
                <td>{TranslateMethods.get(credit.status)}</td>
                <td>{TranslateMethods.get(credit.method)}</td>
                <td>{NumeralMethods.cash(credit.amount)}</td>
                <td>{DateMethod.dateTimeLarge(credit.created)}</td>
                <td>
                    <Button on:click={() => modalStore.open('credit', 'modal', credit)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
